import { render, staticRenderFns } from "./ButtonBackToTop.vue?vue&type=template&id=51f18d44"
import script from "./ButtonBackToTop.vue?vue&type=script&lang=js"
export * from "./ButtonBackToTop.vue?vue&type=script&lang=js"
import style0 from "./ButtonBackToTop.vue?vue&type=style&index=0&id=51f18d44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports